import DS3_FormHelpers from './FormHelpers';

var DS3_DispatchEvents = new Object();

DS3_DispatchEvents.version = '1.0.0';

DS3_DispatchEvents.onFormSubmitted = function($form, data) {

  var demoTypeEl = DS3_FormHelpers.getDemoTypeField($form);
  var demoTypeCheckedEl = DS3_FormHelpers.getDemoTypeCheckedField($form);
  var userData = data.submissionValues;

  var demoType = demoTypeCheckedEl.length
    ? demoTypeCheckedEl.val()
    : demoTypeEl.val();

  if (helpers.shouldDebug('ds3')) console.log('[DS3.DispatchEvents] onFormSubmitted: demoType userData', demoType, userData);

  var dataLayerData = {};

  switch (demoType) {
    case 'demo_now':

      dataLayerData = helpers.dlSanitize({
        event: 'ds3_demo_now_cta',
        event_name: 'ds3_demo_now_cta',
        click_url: window.location.href,

        // User data (must match your GTM DLV variable names)
        fname: helpers.splitFullName(userData.full_name)['first'],
        lname: helpers.splitFullName(userData.full_name)['last'],
        email: userData.email,
        phone: userData.phone,

        // Extra identifiers
        // hubspot_id: formData.hubspotId,
        event_id: crypto.randomUUID(),
        page_url: window.location.href,

        // Meta cookies (already exist client-side, but you can send explicitly too)
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc')

      });

      if (helpers.shouldDebug('ds3')) console.log('[DS3.DispatchEvents] dataLayerData', dataLayerData);

      dataLayer.push(dataLayerData);

      break;

    case 'demo_scheduled':

      dataLayerData = helpers.dlSanitize({
        event: 'ds3_schedule_cta',
        event_name: 'ds3_schedule_cta',
        click_url: window.location.href,

        // User data (must match your GTM DLV variable names)
        fname: helpers.splitFullName(userData.full_name)['first'],
        lname: helpers.splitFullName(userData.full_name)['last'],
        email: userData.email,
        phone: userData.phone,

        // Extra identifiers
        // hubspot_id: formData.hubspotId,
        event_id: crypto.randomUUID(),
        page_url: window.location.href,

        // Meta cookies (already exist client-side, but you can send explicitly too)
        fbp: Cookies.get('_fbp'),
        fbc: Cookies.get('_fbc')

      });

      if (helpers.shouldDebug('ds3')) console.log('[DS3.DispatchEvents] dataLayerData', dataLayerData);

      dataLayer.push(dataLayerData);

      break;
  }

}

export default DS3_DispatchEvents;

